import React, { useEffect } from "react";
import { Link } from "react-router-dom";

import { ReactComponent as Financeiro } from "../../assets/novosicones/menu/Financeiro.svg";
import { ReactComponent as Financiamento } from "../../assets/novosicones/menu/Financiamento.svg";
import { ReactComponent as MeuImovel } from "../../assets/novosicones/menu/MeuImovel.svg";
import { ReactComponent as MeuPerfil } from "../../assets/novosicones/menu/MeuPerfil.svg";
import { ReactComponent as Principal } from "../../assets/novosicones/menu/Principal.svg";

import { ReactComponent as Solicitacoes } from "../../assets/novosicones/menu/Solicitacoes.svg";
import { ReactComponent as PodeMorarFull } from "../../assets/novosicones/podemorarfull.svg";

import Fade from "@material-ui/core/Fade";

import "./styles.scss";

const Menu = ({ tema, responsivo }) => {
  useEffect(() => {
    var url = window.location.href.toString();
    let itensMenu = Array.from(document.getElementsByClassName("item-menu"));
    itensMenu.forEach((item) => {
      item.classList.remove("selectedDirecional");
      item.classList.remove("selectedRiva");
      if (!url.includes(item.attributes[1].value)) {
        item.style.color = "#E8E8E8";
      } else {
        if (tema.tipo == "Riva") {
          item.classList.add("selectedRiva");
        } else {
          item.classList.add("selectedDirecional");
        }
      }
    });
  }, [tema]);

  var idResponsivo = "";

  if (responsivo) idResponsivo = "Responsivo";

  return (
    <Fade in>
      <div className="menu centralized">
        <nav>
          <ul className="centralized-space-between">
            <div className="menu__iconeMobile centralized">
              <PodeMorarFull />
            </div>
            <Link to="/interna">
              <li
                id={`btnHome${idResponsivo}`}
                key={`btnFinanceiro${idResponsivo}`}
                item="interna"
                className="centralized-column item-menu selected"
              >
                <Principal className="hoverIconsMenu" />

                <span>Principal</span>
              </li>
            </Link>
            <Link to="/meu-perfil">
              <li
                id={`btnMeuPerfil${idResponsivo}`}
                key={`btnFinanceiro${idResponsivo}`}
                item="perfil"
                className="centralized-column item-menu"
              >
                <MeuPerfil className="hoverIconsMenu" />

                <span> Meu perfil</span>
              </li>
            </Link>

            <Link to="/meu-imovel">
              <li
                id={`btnMeuImovel${idResponsivo}`}
                key={`btnFinanceiro${idResponsivo}`}
                item="imovel"
                className="centralized-column item-menu"
              >
                <MeuImovel className="hoverIconsMenu" />
                <span> Meu imóvel</span>
              </li>
            </Link>

            <Link to="/solicitacoes">
              <li
                id={`btnAgendamentos${idResponsivo}`}
                key={`btnFinanceiro${idResponsivo}`}
                item="solicitacoes"
                className="centralized-column item-menu"
              >
                <Solicitacoes className="hoverIconsMenu" />
                <span> Solicitações</span>
              </li>
            </Link>

            <Link to="/financeiro">
              <li
                key={`btnFinanceiro${idResponsivo}`}
                id={`btnFinanceiro${idResponsivo}`}
                item="financeiro"
                className="centralized-column item-menu"
              >
                <Financeiro className="hoverIconsMenu" />
                <span> Financeiro</span>
              </li>
            </Link>

            <Link to="/me-ajuda">
              <li
                key={`btnFinanceiro${idResponsivo}`}
                id={`btnMeAjuda${idResponsivo}`}
                item="me-ajuda"
                className="centralized-column item-menu"
              >
                <Financiamento className="hoverIconsMenu" />

                <span>Me Ajuda</span>
              </li>
            </Link>
          </ul>
        </nav>
      </div>
    </Fade>
  );
};

export default Menu;
